<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{this.$route.params.namespace}}</li>
        <li class="breadcrumb-item active">Addon cost</li>
      </ol>
      <h1 class="page-title">Create Addon cost</h1>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <loading-indicator v-if="isLoading"></loading-indicator>
          <form v-else v-on:submit.prevent="onSubmit" autocomplete="off">
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <alert v-show="showAlert"
                  alertClass="m-b-25 alert-dismissible"
                  v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
                  v-bind:iconClass="`${ (successResponse) ? 'md-check' : 'md-close' }`">
                  <span v-if="successResponse">{{successResponse}}</span>
                  <span v-else-if="errorResponse">{{errorResponse}}</span>
                </alert>
                <div class="form-section">
                  <form-group v-bind:error="formErrors.first('team')">
                    <label for="team">Team</label>
                    <v-select v-model="currentTeam" :options="filterItems"></v-select>
                  </form-group>
                  <form-group v-bind:error="formErrors.first('description')" autocomplete="false">
                    <label for="description">Description</label>
                    <input type="text" class="form-control input-lg" placeholder="Description" v-model="description">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('bill_description')">
                    <label for="bill_description">Billing Description</label>
                    <input type="text" class="form-control input-lg"  placeholder="Billing Description" v-model="bill_description" autocomplete="false">
                  </form-group>
                  <form-group>
                    <label for="period">Item Category</label>
                    <div class="row">
                      <div class="col-md-4 col-xs-12" v-for="(item, index) in itemCategory">
                        <div class="alert alert-primary text-xs-center bg-blue-grey-100" role="alert">
                          <i class="icon icon-circle icon-2x md-swap-vertical bg-primary" v-if="item === 'DataTransfer'"></i>
                          <i class="icon icon-circle icon-2x md-tv-list bg-red-600 white" v-else-if="item === 'LiveTranscodeVM'"></i>
                          <i class="icon icon-circle icon-2x md-truck bg-primary" v-else-if="item === 'Shipping'"></i>
                          <i class="icon icon-circle icon-2x md-loupe bg-primary" v-else></i>
                          <p>{{item}}</p>
                          <div class="radio-custom radio-primary">
                            <input type="radio" :value="item" v-model="CurrentItemCategory">
                            <label for="itemCategory"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form-group>
                  <form-group v-bind:error="formErrors.first('cost')">
                    <label class="form-control-label" for="cost">Cost (THB)</label>
                    <input type="number" class="form-control" step="0.01" autocomplete="off" v-model="cost">
                  </form-group>
                  <form-group>
                    <label for="role">Type</label>
                    <div class="radio-custom radio-primary">
                      <input type="radio" value="one-time" v-model="type">
                      <label for="type">One Time</label>
                    </div>
                    <div class="radio-custom radio-primary">
                      <input type="radio" value="recurring" v-model="type">
                      <label for="type">Recurring</label>
                    </div>
                  </form-group>
                  <form-group>
                    <label for="period">Start at Billing Monthly</label>
                    <div class="row">
                      <div class="col-md-4 col-xs-12">
                        <select class="form-control" v-model="currentStartMonth" v-on:change="checkTerminateDate()">
                          <option v-for="(month, index) in monthList" v-bind:value="month">{{month}}</option>
                        </select>
                      </div>
                     <div class="col-md-4 col-xs-12">
                        <select class="form-control" v-model="currentStartYear" v-on:change="checkTerminateDate()">
                          <option v-for="(year, index) in yearList" v-bind:value="year">{{year}}</option>
                        </select>
                      </div>
                    </div>
                  </form-group>
                  <form-group v-if="type === 'recurring'">
                    <label for="period">Terminate at Billing Monthly</label>
                      <div class="row">
                        <div class="col-md-4 col-xs-12">
                          <select class="form-control" v-model="currentTerminateMonth" v-on:change="checkTerminateDate()">
                            <option v-for="(month, index) in monthList" v-bind:value="month">{{month}}</option>
                          </select>
                        </div>
                        <div class="col-md-4 col-xs-12">
                          <select class="form-control" v-model="currentTerminateYear" v-on:change="checkTerminateDate()">
                            <option v-for="(year, index) in yearList" v-bind:value="year">{{year}}</option>
                          </select>
                        </div>
                      </div>
                  </form-group>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                  <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import vSelect from 'vue-select';
import { Validator } from 'vee-validate';
import LoadingIndicator from 'components/LoadingIndicator';
import moment from 'moment';

export default {
  components: {
    FormGroup,
    Alert,
    vSelect,
    LoadingIndicator,
  },
  data: function () {
    return {
      isSubmiting: false,
      isLoading: false,
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      terminateMonthList: [],
      currentStartMonth: moment().startOf('months').format('MMMM'),
      currentStartYear: moment().startOf('months').format('YYYY'),
      currentTerminateMonth: moment().startOf('months').add(6, 'months').format('MMMM'),
      currentTerminateYear: moment().startOf('months').format('YYYY'),
      description: '',
      bill_description: '',
      cost: 500,
      type: 'one-time',
      started_at: '2017-03',
      terminate_at: '2017-03',
      currentTeam: null,
      teams: [],
      CurrentItemCategory: 'LiveTranscodeVM',
      itemCategory: ['LiveTranscodeVM', 'DataTransfer', 'Shipping', 'Custom'],
    };
  },
  created: function() {
    this.isLoading = true;

    this.validator = new Validator();
    this.validator.attach('team', 'required', { prettyName: 'Team' });
    this.validator.attach('description', 'required', { prettyName: 'Description' });
    this.validator.attach('bill_description', 'required', { prettyName: 'Billing Description' });
    this.validator.attach('team_id', 'required', { prettyName: 'Team' });
    this.validator.attach('cost', 'required', { prettyName: 'Cost' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    this.fetchTeams();
  },
  computed: {
    filterItems: function () {
      const temp = [];
      this.teams.forEach((item) => {
        temp.push({ label: item.namespace, value: item.id });
      });
      return temp;
    },
    monthList: function() {
      const list = [];

      const now = moment().startOf('years');
      list.push(now.format('MMMM'));

      for (let i = 0; i < 11; i += 1) {
        list.push(now.add(1, 'months').format('MMMM'));
      }

      return list;
    },
    yearList: function() {
      const list = [];

      const now = moment().startOf('years');
      list.push(now.format('YYYY'));

      for (let i = 0; i < 12; i += 1) {
        list.push(now.add(1, 'years').format('YYYY'));
      }

      return list;
    },
    currentStart: function () {
      const start = moment().year(this.currentStartYear)
        .month(this.currentStartMonth).format('YYYY-MM');
      return start;
    },
    currentTerminate: function () {
      const terminate = moment().year(this.currentTerminateYear)
        .month(this.currentTerminateMonth).format('YYYY-MM');
      return terminate;
    },
  },
  methods: {
    onSubmit: function () {
      // hide alert
      this.showAlert = false;

      this.validator.validateAll({
        description: this.description,
        bill_description: this.bill_description,
        cost: this.cost,
        team: this.currentTeam,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;

        axios.post(`api/admin/billaddons`, {
          description: this.description,
          bill_description: this.bill_description,
          team_id: this.currentTeam.value,
          type: this.type,
          cost: this.cost,
          item_category: this.CurrentItemCategory,
          started_at: this.currentStart,
          terminated_at: this.type === 'recurring' ? this.currentTerminate : null,
        })
        .then((response) => {
          this.isSubmiting = false;
          this.addon = response.data;
          this.successResponse = this.$t('team.response.success');
          this.errorResponse = null;
          this.showAlert = true;

          setTimeout(() => {
            this.$router.push(`/${this.$route.params.namespace}/admin/addon-cost`);
          }, 2000);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errorResponse = this.$t('team.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('team.response.defaultFailed');
          }
          this.showAlert = true;
        });
      })
      .catch(() => {
      });
    },
    fetchTeams: function() {
      const url = `/api/teams?except=reseller&nopage=true`;

      axios.get(url)
      .then((response) => {
        this.teams = response.data;
        this.isLoading = false;
      })
      .catch(() => {

      });
    },
    checkTerminateDate: function () {
      const diffTime = moment(this.currentTerminate).isBefore(this.currentStart);
      const sameTime = moment(this.currentTerminate).isSame(this.currentStart); // true
      if (diffTime || sameTime) {
        const terminate = moment(this.currentStart).add(6, 'months');
        this.currentTerminateMonth = moment(terminate, ['YYYY-MM', moment.ISO_8601]).format('MMMM');
        this.currentTerminateYear = moment(terminate, ['YYYY-MM', moment.ISO_8601]).format('YYYY');
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AddonCostCreator.vue?d02db74c